import { GS, GS_m, Response } from 'back-end-api'
import { saveToLocal, removeFromLocal, getFromLocalOrDefault } from '../Storage'

const TOKENS_LOCAL_STORAGE_KEY = 'TOKENS_LOCAL_STORAGE_KEY'

interface TokensStorage {
  accessToken: string
  refreshToken: string
}

const storeTokens = (tokens: TokensStorage): void => {
  saveToLocal(tokens, TOKENS_LOCAL_STORAGE_KEY)
}

export const eraseTokens = (): void => {
  removeFromLocal(TOKENS_LOCAL_STORAGE_KEY)
}

export const getAccessToken = (): string | undefined => {
  const tokens = getFromLocalOrDefault<TokensStorage | undefined>(
    undefined,
    TOKENS_LOCAL_STORAGE_KEY
  )
  return tokens?.accessToken
}

const getRefreshToken = (): string | undefined => {
  const tokens = getFromLocalOrDefault<TokensStorage | undefined>(
    undefined,
    TOKENS_LOCAL_STORAGE_KEY
  )
  return tokens?.refreshToken
}

export const login = async (
  request: GS_m.EndpointsLoginRequest
): Promise<Response<GS_m.EndpointsLoginResponse>> => GS.login(request)

export const logout = async (request: GS_m.EndpointsLogoutRequest): Promise<void> => {
  eraseTokens()
  await GS.logout(request)
}

export const multiFactorAuth = async (
  request: GS_m.EndpointsMultiFactorAuthRequest
): Promise<Response<GS_m.EndpointsMultiFactorAuthResponse>> => {
  const res = await GS.multiFactorAuth(request)

  if (res.data) {
    storeTokens({ accessToken: res.data.access_token, refreshToken: res.data.refresh_token })
  }

  return res
}

export const refresh = async (): Promise<string | null> => {
  const refreshToken = getRefreshToken()

  if (refreshToken && !GS.isTokenExpiringWithin(refreshToken, 1000 * 60)) {
    const res = await GS.refresh({ refresh_token: refreshToken })
    if (res.data?.access_token && res.data?.refresh_token) {
      storeTokens({ accessToken: res.data.access_token, refreshToken: res.data.refresh_token })
      return res.data.access_token
    }
  }

  return null
}
